/** Saves an in-memory blob through a temporary anchor so the browser shows its download prompt. */
export const triggerBlobDownload = (blob: Blob, filename: string): void => {
  const blobUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = blobUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(blobUrl);
};
